import { Directive } from '@angular/core';
import { LcsMultiSelectTriggerComponent } from '@lcs/shared/multi-select';

import { entityMultiSelectText } from 'src/app/common-components/multi-select/entity-multi-select-text-content';
import { UserOption } from 'src/app/pages/user-register/models/user-option.interface';

@Directive({
    selector: 'lcs-multi-select-trigger[ndtUserMultiSelect]',
    standalone: false
})
export class UserMultiSelectTriggerDirective {
   constructor(trigger: LcsMultiSelectTriggerComponent<UserOption>) {
      trigger.getTextContent = entityMultiSelectText(trigger, 'user');
   }
}
